module.exports = __webpack_public_path__ + "c3c219457d45e24cc7f5a9e2f8075522.pdf";